import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ContactUsModel, contactUsModelDefaultValues } from 'src/app/components/global/contact-us';
import { AuthService } from 'src/app/services/auth.service';
import { ContactUsService } from 'src/app/services/contact-us.service';
import { ParticipantThemeService } from 'src/app/services/participant-theme.service';
import { ToastService } from 'src/app/services/toast-service.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
    standalone: false
})
export class ContactUsComponent {

  contactusModel:ContactUsModel=contactUsModelDefaultValues()
  participantClassByRole: string = '';
  bannerClass: string = '';
  translations: any;
  llttfPage:boolean = false;
  subHeading=""
  email: string = ""
  isLoggedIn = false
  isSubmitted = false
  cancelPath = '/bb-login'

  constructor(
    private translationservice:TranslationService,
    private themeService: ParticipantThemeService,
    private contactusservice:ContactUsService,
    private toastservice:ToastService,
    private authservice:AuthService)
  {}

  ngOnInit()
  {
    this.themeService.setParticipantTheme();
    this.participantClassByRole = this.themeService.participantClassByRole;
    this.llttfPage = this.themeService.llttfPage;
    this.isLoggedIn = !!this.authservice.checkTokenExpiry();
    this.bannerClass = this.getBannerClass();
    this.translationservice.getTranslation().subscribe({
      next: (translations) => {
        this.translations = translations;
        this.subHeading = this.contactusservice.getContactUsSubHeading(this.translations, this.isLoggedIn);
      }
    })
    if (this.isLoggedIn) {
      this.email = this.authservice.getUserLoginData().username;
      this.cancelPath = this.authservice.getUserLoginData().isParticipant
        ? '/dashboard-participant'
        : '/dashboard-bb';
    }
  }

  private getBannerClass(): string {
    if (!this.isLoggedIn) {
      return '';
    }

    if (this.authservice.getUserLoginData().isParticipant) {
      return this.participantClassByRole;
    }

    return 'bb-coached-color';
  }

  onSubmit(form: NgForm)
  {
    this.isSubmitted = true;

    if (form.invalid || !this.email?.trim()) {
      return;
    }

    this.contactusModel.toEmailId = this.email.trim();
    this.contactusservice.createEnquiry(this.contactusModel).subscribe({
      next: (response) => {
        this.toastservice.showMessage("Enquiry submitted successfully.")
        this.contactusModel = contactUsModelDefaultValues();
      }
    })
  }
}
